var defaultTableSettings = {
  actions: {
    position: 'right',
    custom: [
      { name: 'moveUp', title: '&#9650;&nbsp;&nbsp;' },
      { name: 'moveDown', title: '&#9660;' }
    ]
  },
  add: { confirmCreate: true },
  edit: { confirmSave: true }
};

export var accountTypeTableSettings = {
  columns: {
    name: {
      title: 'Name',
      filter: false,
      sort: false,
      width: '25%'
    },
    description: {
      title: 'Description',
      filter: false,
      sort: false,
      width: '40%',
      editor: { type: 'textarea'}
    },
    minDeposit:{
      title: 'Min deposit',
      filter: false,
      sort: false,
      width: '15%'
    },
    type: {
      title: 'Type',
      filter: false,
      sort: false,
      width: '25%'
    }
  },
  ...defaultTableSettings
};
export var promotionTableSettings = {
  columns: {
    name: {
      title: 'Name',
      filter: false,
      sort: false,
      width: '25%'
    },
    isActive: {
      title: 'Is active',
      filter: false,
      sort: false,
      width: '10%',
      editor: { type: 'checkbox' },
      valuePrepareFunction: value => Boolean(value) ? value : (value === "true")
    },
    url: {
      title: 'URL',
      filter: false,
      sort: false,
      width: '25%'
    },
    description: {
      title: 'Description',
      filter: false,
      sort: false,
      width: '40%',
      editor: { type: 'textarea' }
    }
  },
  ...defaultTableSettings
};
export var educationProgramTableSettings = {
  columns: {
      name: {
        title: 'Name',
        filter: false,
        sort: false,
        width: '50%'
      },
      url: {
        title: 'URL',
        filter: false,
        sort: false,
        width: '50%'
      }
  },
  ...defaultTableSettings
};

export function confirmNameNotEmpty(event) {
  if (event.newData.name == '') {
    event.confirm.reject();
  } else {
    event.confirm.resolve();
  }
}

export function onMoveAccountTypes(event) {
  this.AccountTypesData.getAll().then(data => onTableRowMoved(event, data));
}
export function onMovePromotions(event) {
  this.PromotionsData.getAll().then(data => onTableRowMoved(event, data));
}
export function onMoveEducationPrograms(event) {
  this.EducationProgramsData.getAll().then(data => onTableRowMoved(event, data));
}

function onTableRowMoved(event, array) {
  var index = array.indexOf(event.data);
  if (event.action == 'moveUp' && index > 0) {
    array_move(array, index, index - 1);
  } else if (event.action == 'moveDown' && index + 1 < array.length) {
    array_move(array, index, index + 1);
  }
  event.source.load(array);
}

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
          arr.push(undefined);
      }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
}


// WEBPACK FOOTER //
// ./src/app/brokers/components/scripts/broker-edit-tables-config.ts